class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const btn = this.querySelector('.facet-filters .facet-filters__label');
    if (btn) {
      const elmOptions = this.querySelector('.facet-filters .select');
      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show');
      });
    }

    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(
      (element) => {
        let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked');
        if (elmActiveOption.length > 0) {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.remove('hidden');
            element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')';
          }
        } else {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.add('hidden');
          }
        }

        if (element.querySelectorAll('.mobile-facets__list input[type="checkbox"]').length == 1) {
          element.classList.add('one-option');
        } else {
          element.classList.remove('one-option');
        }
      }
    );

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active');
      }
    } else {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active');
      }
    }

    this.onHandleParamsFilter();
    this.initSortByRadios();
  }

  initSortByRadios() {
    // Handle sort by radio buttons in drawer type filter
    const sortByRadios = this.querySelectorAll('input[type="radio"][name="sort_by"]');
    // Also try to find radios in the entire document if none found in form
    const allSortByRadios = document.querySelectorAll('input[type="radio"][name="sort_by"]');

    sortByRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.debouncedOnSubmit(event);
        // Close the dropdown after selection
        const selectElement = event.target.closest('.select');
        if (selectElement && selectElement.classList.contains('show')) {
          selectElement.classList.remove('show');
        }
      });
    });

    // If no radios found in this form, try to add listeners to all radios in document
    if (sortByRadios.length === 0 && allSortByRadios.length > 0) {
      allSortByRadios.forEach((radio) => {
        radio.addEventListener('change', (event) => {
          // Find the closest facet-filters-form
          const facetForm = event.target.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (facetForm && facetForm.debouncedOnSubmit) {
            facetForm.debouncedOnSubmit(event);
          }
          // Close the dropdown after selection
          const selectElement = event.target.closest('.select');
          if (selectElement && selectElement.classList.contains('show')) {
            selectElement.classList.remove('show');
          }
        });
      });
    }
  }

  onHandleParamsFilter() {
    const queryString = window.location.search;
    if (queryString) {
      document.querySelector('.mobile-facets__footer--bottom .mobile-facets__clear-wrapper').style.color = '#3A3631';
    } else {
      document.querySelector('.mobile-facets__footer--bottom .mobile-facets__clear-wrapper').style.color = '#AEA69A';
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const btn = document.querySelector('.facet-filters .facet-filters__label');
    if (btn) {
      const elmOptions = document.querySelector('.facet-filters .select');
      const labelElement = document.querySelector('.facet-filters__label--name');

      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show');
        if (elmOptions.classList.contains('show')) {
          labelElement.style.display = 'none';
        } else {
          labelElement.style.display = '';
        }
      });
    }

    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(
      (element) => {
        let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked');
        if (elmActiveOption.length > 0) {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.remove('hidden');
            element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')';
          }
        } else {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.add('hidden');
          }
        }
      }
    );

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active');
      }
    } else {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active');
      }
    }

    // Reinitialize sort by radio buttons after AJAX update
    const facetForms = document.querySelectorAll('facet-filters-form');
    facetForms.forEach((form) => {
      const sortByRadios = form.querySelectorAll('input[type="radio"][name="sort_by"]');
      sortByRadios.forEach((radio) => {
        // Remove old event listeners by cloning the node
        const newRadio = radio.cloneNode(true);
        radio.parentNode.replaceChild(newRadio, radio);
        // Add new event listener
        newRadio.addEventListener('change', (event) => {
          const facetForm = event.target.closest('facet-filters-form');
          if (facetForm && facetForm.debouncedOnSubmit) {
            facetForm.debouncedOnSubmit(event);
          }
          // Close the dropdown after selection
          const selectElement = event.target.closest('.select');
          if (selectElement && selectElement.classList.contains('show')) {
            selectElement.classList.remove('show');
          }
        });
      });
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    Array.from(document.querySelectorAll('.filter-drawer-count')).forEach((section) => {
      section.textContent =
        '(' + html.getElementById('filter-count').textContent.replace('(', '').replace(')', '').trim() + ')';
    });

    const queryString = window.location.search;
    if (queryString) {
      document.querySelector('.mobile-facets__footer .mobile-facets__clear-wrapper').style.color = '#3A3631';
    } else {
      document.querySelector('.mobile-facets__footer .mobile-facets__clear-wrapper').style.color = '#AEA69A';
    }

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();

    this.querySelectorAll('.range-wrap').forEach((wrap) => {
      const range = wrap.querySelector('.range');
      const bubble = wrap.querySelector('.bubble');

      range.addEventListener('input', () => {
        this.setBubble(range, bubble);
      });
      this.setBubble(range, bubble);
    });

    this.handleCustomChangeInput();
  }

  onRangeChange(event) {
    // this.adjustToValidValues(event.currentTarget);
    // this.setBubble(event.currentTarget, bubble);
    this.setMinAndMaxValues();
  }

  setBubble(range, bubble) {
    const dataSymbol = this.getAttribute('data-symbol');
    const val = range.value;
    // const min = range.min ? range.min : 0;
    // const max = range.max ? range.max : 0;
    // const newVal = Number(((val - min) * 100) / (max - min));

    bubble.innerHTML = `${val}${dataSymbol}`;
    // Sorta magic numbers based on size of the native UI thumb
    // bubble.style.left = `calc(${newVal}% + (${-5 - newVal * 0.15}px))`;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    // Set default min and max values to 0 if not present
    if (!minInput.value) minInput.value = '';
    if (!maxInput.value) maxInput.value = '';

    // Update min and max attributes based on the other input's value
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  handleCustomChangeInput() {
    try {
      const rangeInput = document.querySelectorAll('.range-input input'),
        priceInput = document.querySelectorAll('.price-input input'),
        range = document.querySelector('.slider .progress');

      let priceGap = 0;

      priceInput.forEach((input) => {
        input.addEventListener('input', (e) => {
          let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);
          if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
            if (e.target.className === 'input-min') {
              rangeInput[0].value = minPrice;
              range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
            } else {
              rangeInput[1].value = maxPrice;
              range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + '%';
            }
          }
        });
      });

      rangeInput.forEach((input) => {
        input.addEventListener('input', (e) => {
          let minVal = parseInt(rangeInput[0].value),
            maxVal = parseInt(rangeInput[1].value);
          const dataSymbol = document.querySelector('price-range').getAttribute('data-symbol');

          if (maxVal - minVal < priceGap) {
            if (e.target.className === 'range-min') {
              rangeInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.left = (minVal / rangeInput[0].max) * 100 + '%';
            range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
          }

          document.querySelector('.label-min-price').textContent = minVal + dataSymbol;
          document.querySelector('.label-max-price').textContent = maxVal + dataSymbol;
        });
      });
    } catch (error) {
      console.error('Error: ', error);
    }
  }
}

customElements.define('price-range', PriceRange);

function handleTriggerCloseFilter() {
  const btnClose = document.querySelector('.btn-close-filter');
  if (!btnClose) return;

  btnClose.addEventListener('click', function () {
    document.querySelector('.mobile-facets__close').click();
  });
}

handleTriggerCloseFilter();

function rangeMinValFunc(rangeVal) {
  const rangeMinWidth = (document.querySelector('.range-wrap.min .bubble').textContent = rangeVal);
  document.querySelector('.range-wrap.min .bubble').textContent = rangeVal + '€';
  // const rangeMaxWidth = document.querySelector('.range-wrap.max .bubble').textContent = rangeVal

  document.querySelector('.range-wrap.min .bubble').style.left = 'calc(' + rangeMinWidth + '%)';
  // document.querySelector('.range-wrap.max .bubble').style.left = "calc("+rangeMaxWidth+"% - 8px)"
}

function rangeMaxValFunc(rangeVal) {
  // const rangeMinWidth = document.querySelector('.range-wrap.min .bubble').textContent = rangeVal
  const rangeMaxWidth = (document.querySelector('.range-wrap.max .bubble').textContent = rangeVal);
  document.querySelector('.range-wrap.max .bubble').textContent = rangeVal + '€';

  // document.querySelector('.range-wrap.min .bubble').style.left = "calc("+rangeMinWidth+"% - 8px)"
  document.querySelector('.range-wrap.max .bubble').style.left = 'calc(' + rangeMaxWidth + '%)';
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
